module.exports = __webpack_public_path__ + "img/rif-logo.ac1d8877.png";